/* eslint-disable no-unreachable */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
export default function AppLoader() {
    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", width: "100%", position: "fixed", top: "0", left: "0", backgroundColor: "rgba(246, 245, 244, 0.92)", zIndex: "9999" }}>
           <img src={require('../../../../assets/portant-mark-animated.svg')} alt="Loading" width={72} height={72} />
        </div>
    )
}
